import * as React from "react";

function ArrowDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={30} height={51} viewBox="0 0 30 51" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.586 50.414a2 2 0 002.828 0l12.728-12.728a2 2 0 10-2.828-2.828L15 46.172 3.686 34.858a2 2 0 10-2.828 2.828l12.728 12.728zM13 0v49h4V0h-4z"
        fill="#66CBEC"
      />
    </svg>
  );
}

export default ArrowDown;
